import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import '../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';
import { FormField } from '../FormField/FormField.js';
import cuid from 'cuid';

var Select = forwardRef(function (_a, ref) {
    var children = _a.children, defaultValue = _a.defaultValue, placeholder = _a.placeholder, invalid = _a.invalid, disabled = _a.disabled, onChange = _a.onChange, ariaLabelledby = _a["aria-labelledby"], ariaLabel = _a["aria-label"], value = _a.value, 
    // FormField props
    optional = _a.optional, id = _a.id, _b = _a.size, size = _b === void 0 ? "md" : _b, props = __rest(_a, ["children", "defaultValue", "placeholder", "invalid", "disabled", "onChange", "aria-labelledby", "aria-label", "value", "optional", "id", "size"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var containerStyles = handleStyleProps({
        themeKey: "selectContainer",
        invalid: invalid,
        disabled: disabled,
    }).css;
    var selectStyles = handleStyleProps({
        themeKey: "select",
        size: size,
    }).css;
    var handleOnChange = function (event) {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    var fieldId = id || cuid();
    return (jsx(FormField, __assign({ optional: optional, fieldId: fieldId }, props, { children: jsx(Box, __assign({ css: containerStyles }, { children: jsxs(Box, __assign({ component: "select", id: fieldId, ref: ref, defaultValue: defaultValue || (value === undefined ? "" : undefined), value: value, "aria-invalid": Boolean(invalid), "aria-disabled": Boolean(disabled), disabled: Boolean(disabled), css: selectStyles, onChange: handleOnChange, "aria-labelledby": ariaLabelledby, "aria-label": ariaLabel }, (!optional && { "aria-required": !optional }), { children: [placeholder && (jsx("option", __assign({ value: "", disabled: true }, { children: placeholder }))), children] })) })) })));
});
Select.displayName = "Select";

export { Select };
//# sourceMappingURL=Select.js.map
